import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { CustomValidators } from 'src/app/utils';
import swal, { SweetAlertType } from 'sweetalert2';
import { UserService } from './../../utils/cargo-driver-check-in-service/services/user.service';
import { RecoverPasswordForm } from './types/recover-password-form';

@Component({
    selector: 'app-recover-pass',
    templateUrl: './recover-password.component.html',
    styleUrls: ['./recover-password.component.scss'],
    standalone: false
})
export class RecoverPassword implements OnInit {

    public recoveryForm: FormGroup<RecoverPasswordForm>;
    public sending: boolean = false;
    public alertMessage: string = '';
    private timerMessageError: number;

    constructor(
        private userService: UserService,
        private router: Router
    ) {

    }

    ngOnInit(): void {
        this.createForm();
    }

    createForm(): void {
        this.recoveryForm = new FormGroup<RecoverPasswordForm>({
            usr_email: new FormControl('', [
                Validators.required,
                Validators.email
            ]),
            confirm_email: new FormControl('', [
                Validators.required,
                Validators.email
            ]),
        }, {
            validators: [
                <ValidatorFn>CustomValidators.match('usr_email', 'confirm_email')
            ]
        });
    }

    sendEmail(form: FormGroup<RecoverPasswordForm>): void {
        if (form.invalid || this.sending) {
            return;
        }

        this.sending = true;
        const usrEmail = this.recoveryForm.get('usr_email').value;

        this.userService.sendEmailResetPassword(usrEmail)
            .pipe(
                map(() => {
                    return {
                        title: 'Good job!',
                        message: `You'll receive a password reset email if <strong class="text-nowrap">${usrEmail}</strong> is linked to a SprintPass account.`,
                        type: 'success'
                    };
                }),
                catchError(error => {
                    console.error(error);

                    return of({
                        title: 'Ooops...',
                        message: error?.message || 'Something went wrong!',
                        type: 'error'
                    });
                }),
                finalize(() => {
                    this.sending = false;
                })
            )
            .subscribe({
                next: response => {
                    swal({
                        title: response.title,
                        html: response.message,
                        type: <SweetAlertType>response.type,
                        showConfirmButton: true,
                        confirmButtonText: 'OK',
                    })
                        .then(() => {
                            this.router.navigateByUrl('login');
                        });
                }
            });
    }

    hideAlertMessage() {
        window.clearTimeout(this.timerMessageError);
        this.alertMessage = '';
    }

    showAlertMessage(message: string) {
        window.clearTimeout(this.timerMessageError);
        this.alertMessage = message;

        this.timerMessageError = window.setTimeout(() => {
            this.alertMessage = '';
        }, 5000);
    }
}
